// Pre-fill defaults applied when a Primary Device Type is picked on a fresh
// device form. The form passes freshValue: true only on devices/new so we
// never clobber existing data. The Reset to defaults button (separate flow)
// is the explicit way to reapply on an existing device.
//
// Keys match device type names exactly (case-sensitive — primary type select
// renders type.name as the option text).

export const DEVICE_TYPE_DEFAULTS = {
  Pedal: {
    ports: [
      { direction: "input", name: "Input", connector: "quarter_inch_ts",
        signal_type: "audio", signal_level: "instrument" },
      { direction: "output", name: "Output", connector: "quarter_inch_ts",
        signal_type: "audio", signal_level: "instrument" },
    ],
    power: {
      voltage_min: 9,
      voltage_max: 9,
      polarity: "center_negative",
      connector: "barrel_2_1mm",
    },
    openAudioEffect: true,
  },
  Microphone: {
    ports: [
      { direction: "output", name: "Output", connector: "xlr",
        signal_type: "audio", signal_level: "mic" },
    ],
  },
  "Powered Speaker": {
    ports: [
      { direction: "input", name: "Input", connector: "xlr_combo",
        signal_type: "audio", signal_level: "mic_line" },
    ],
    power: {
      connector: "ac_cable",
    },
  },
  "Wireless Receiver": {
    ports: [
      { direction: "input", name: "Wireless In", connector: "wireless",
        signal_type: "audio" },
      { direction: "output", name: "Output", connector: "xlr",
        signal_type: "audio", signal_level: "line" },
    ],
  },
  "Wireless Transmitter": {
    ports: [
      { direction: "output", name: "Wireless Out", connector: "wireless",
        signal_type: "audio" },
    ],
  },
  "Power Supply": { power: { connector: "ac_cable" } },
  "Power Conditioner": { power: { connector: "ac_cable" } },
  "Surge Protector": { power: { connector: "ac_cable" } },
  "UPS": { power: { connector: "ac_cable" } },
};
